<template>
    <div>
        {{ productData.c_color }}
        <img class="image" :src="productData.productphoto" :alt="productData.name" @error="imageLoadError" >

    </div>
</template>

<script>
export default {
    props: {
        upc: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        return {
            productData: {},
        }
    },
    created() {
        if (window.location.hostname === 'localhost') {
            this.baseurl = '//staging-emea-shiseido.demandware.net'
        } else {
            this.baseurl = window.location.origin
        }

        this.fetchData()
    },
    methods: {
        imageLoadError() {
            this.productData.productphoto = `http://sits-pod45.demandware.net/dw/image/v2/BBSK_STG/on/demandware.static/-/Sites-itemmaster_shiseido/default/images/swatch/${ this.upc.substring(1) }.jpg?sw=40&sh=40&sm=fit`
        },
        fetchData() {
            const info_url = this.baseurl.concat(`/s/Sites-shiseido_us-Site/dw/shop/v17_3/products/${ this.upc }/prices?client_id=fc5bfc89-edfb-44af-bca2-2e1c6102a5dc`)

            this.$http.jsonp(info_url).then((response) => {
                console.log(response.data)

                response.data.productphoto = '//sits-pod45.demandware.net/dw/image/v2/BBSK_STG/on/demandware.static/-/Sites-itemmaster_shiseido/default/images/swatch/'
                    .concat(this.upc)
                    .concat('.jpg?sw=40&sh=40&sm=fit')

                this.productData = response.data
                this.productData.productlink = `/on/demandware.store/Sites-shiseido_us-Site/en_US/Product-Show?pid=${ this.upc }`
            }, () => {
                /* error callback */
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// development/js/color.vue